
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER, NgZone } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { AppComponent } from './app.component';
import { RoutingModule } from './app-routing.module';
import { ToastModule } from 'ng-uikit-pro-standard';
import { KeycloakAngularModule } from 'keycloak-angular';
import { SharedModule } from './shared/shared.module';
import { ExceptionHandlingService } from './shared/exception-handling.service';
import { AppConstants } from "./config.service";
import { HTTP_INTERCEPTORS,HttpClient, HttpClientModule } from '@angular/common/http';
import { HttpTokenInterceptor} from './interceptors';
import { LazyElementsModule } from '@angular-extensions/elements';
import { UnderConstructionComponent } from './shared/components/under-construction.component'
import {SearchSelectionLettersComponent} from 'src/app/views/search-selection-letters/search-selection-letters.component'
import { ChangeTestingLocationComponent } from './views/change-testing-location/change-testing-location.component'
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { YearPickerComponent } from './views/change-testing-location/components/year-picker/year-picker.component'
import {ErrorsModule} from 'src/app/views/errors/errors.module';
import { SearchNotificationsComponent } from './views/search-notifications/search-notifications.component'
import { SearchComponentsComponent } from './views/search-components/search-components.component'
import {CustomSelectionWebComponent} from './views/custom-selections-web/custom-selections-web.component'
import { CreateSelectionsComponent } from './views/create-selections/create-selections.component'
import {ComponentTestingReminderNoticesComponent} from './views/component-testing-reminder-notices/component-testing-reminder-notices.component';
import {CreateSelectionsCustomerComponent} from './views/create-selections-customers/create-selections-customers.component';
import {SearchSelectionsComponent} from './views/search-selections/search-selections.component'
import { GenerateSuspensionNoticesComponent } from './views/generate-suspension-notices/generate-suspension-notices.component';
import { RecordViolationsComponent } from './views/record-violations/record-violations.component';
import { UnauthorizedComponent } from './views/unautorized-component/unauthorised-page.component';
export function initConfig(config: AppConstants) {
  return () => config.endApIPoints();
}

export function keycloakInitConfig(keycloak: AppConstants) {
  return () => keycloak.load();
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    UnderConstructionComponent,
    SearchSelectionLettersComponent,
    ChangeTestingLocationComponent,
    CreateSelectionsComponent,
    CustomSelectionWebComponent,
    SearchComponentsComponent,
    SearchNotificationsComponent,
    ComponentTestingReminderNoticesComponent,
    CreateSelectionsCustomerComponent,
    SearchSelectionsComponent,
    GenerateSuspensionNoticesComponent,
    YearPickerComponent,
    RecordViolationsComponent,
    //
    UnauthorizedComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    KeycloakAngularModule,
    ToastModule.forRoot({ positionClass: 'md-toast-bottom-right', tapToDismiss: true}),
    FilterPipeModule,
    FormsModule,
    LazyElementsModule,
    SharedModule,
    HttpClientModule,
    RoutingModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ErrorsModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
    AppConstants,ExceptionHandlingService,
    { provide: APP_INITIALIZER, useFactory: initConfig, deps: [AppConstants], multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: keycloakInitConfig,
      multi: true,
      deps: [AppConstants]
    }

   ],
  bootstrap: [ AppComponent ],
  schemas:   [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule {
  constructor(private ngZone: NgZone) {
    (window as any).ngZone = ngZone;
  }
 }